import React from "react";
import {
  Alert,
  Form,
  Icon,
  Input,
  Button,
  Row,
  Col,
  Select,
  Checkbox,
  InputNumber,
} from "antd";

import get from "lodash/get";
import filter from "lodash/filter";
import { connect } from "react-redux";

import classes from "./SettingsPatientEventForm.css";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import {
  createPatientEvent,
  getForms,
  linkFormsToPatientEvent,
  updatePatientEvent,
} from "../../api/requests";

class SettingsPatientEventForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      forms: [],
      requestResult: {},
    };
  }

  async componentDidMount() {
    try {
      const { data } = await getForms();
      this.setState({ forms: data });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          const { data } = this.props.id
            ? await updatePatientEvent({
                id: this.props.id,
                name: values.name,
                tracking_patient_event: values.tracking_patient_event,
                hide_if_pending: values.hide_if_pending,
                order_index: values.order_index,
                show_on_patient_page: values.show_on_patient_page,
                requires_validation: values.requires_validation,
                track_in_finance: values.track_in_finance,
                required_for_completion: values.required_for_completion,
                cf_field_required_for_billing: values.cf_field_required_for_billing_check
                  ? values.cf_field_required_for_billing
                  : undefined,
              })
            : await createPatientEvent({
                name: values.name,
                codename: values.codename,
                state: values.state,
                tracking_patient_event: values.tracking_patient_event,
                hide_if_pending: values.hide_if_pending,
                order_index: values.order_index,
                show_on_patient_page: values.show_on_patient_page,
                requires_validation: values.requires_validation,
                track_in_finance: values.track_in_finance,
                required_for_completion: values.required_for_completion,
                cf_field_required_for_billing: values.cf_field_required_for_billing_check
                  ? values.cf_field_required_for_billing
                  : undefined,
              });

          await linkFormsToPatientEvent({
            id: data.id,
            data: this.state.forms
              .filter((item) => values.form_events.includes(item.id))
              .map((item) => ({ form_id: item.id })),
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }

          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", "Error"),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );

            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { isPredefined } = this.props;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.i18n.t(
              "NamespaceSettingsPatientEventForm:Patient Event"
            )}
          </h4>

          <Row gutter={12}>
            <Col span={24}>
              <label>
                <b>
                  {this.props.i18n.t(
                    "NamespaceSettingsPatientEventForm:Patient Event"
                  )}
                  :
                </b>
                <Form.Item>
                  {getFieldDecorator("name", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "name"),
                  })(<Input type="text" disabled={isPredefined} />)}
                </Form.Item>
              </label>
            </Col>
            <Col span={24}>
              <label>
                <b>
                  {this.props.i18n.t("NamespaceSettingsPatientEventForm:Form")}:
                </b>
                <Form.Item>
                  {getFieldDecorator("form_events", {
                    rules: [{ required: false, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "form_events", []).map(
                      (item) => item.form.id
                    ),
                  })(
                    <Select mode="multiple" disabled={isPredefined}>
                      {filter(
                        this.state.forms,
                        (form) => !form.is_predefined
                      ).map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={24}>
              <Form.Item>
                <b>
                  {this.props.i18n.t("NamespaceSettingsPatientEventForm:Order")}
                  :
                </b>
                {getFieldDecorator("order_index", {
                  initialValue: get(this.props, "order_index", 0),
                })(<InputNumber />)}
              </Form.Item>
            </Col>

            <Col span={24}>
              <label>
                {getFieldDecorator("show_on_patient_page", {
                  initialValue: get(this.props, "show_on_patient_page", false),
                  valuePropName: "checked",
                })(
                  <Checkbox>
                    {this.props.i18n.t(
                      "NamespaceSettingsPatientEventForm:Show on patient page"
                    )}
                  </Checkbox>
                )}
              </label>
            </Col>
            <Col span={24}>
              <label>
                {getFieldDecorator("tracking_patient_event", {
                  initialValue: get(
                    this.props,
                    "tracking_patient_event",
                    false
                  ),
                  valuePropName: "checked",
                })(
                  <Checkbox>
                    {this.props.i18n.t(
                      "NamespaceSettingsPatientEventForm:Tracking Patient Events"
                    )}
                  </Checkbox>
                )}
              </label>
            </Col>
            <Col span={24}>
              <label>
                {getFieldDecorator("hide_if_pending", {
                  initialValue: get(this.props, "hide_if_pending", false),
                  valuePropName: "checked",
                })(
                  <Checkbox>
                    {this.props.i18n.t(
                      "NamespaceSettingsPatientEventForm:Hide event if pending."
                    )}
                  </Checkbox>
                )}
              </label>
            </Col>

            <Col span={24}>
              <label>
                {getFieldDecorator("requires_validation", {
                  initialValue: get(this.props, "requires_validation", false),
                  valuePropName: "checked",
                })(
                  <Checkbox>
                    {this.props.i18n.t(
                      "NamespaceSettingsPatientEventForm:Requires Validation"
                    )}
                  </Checkbox>
                )}
              </label>
            </Col>
            <Col span={24}>
              <label>
                {getFieldDecorator("track_in_finance", {
                  initialValue: get(this.props, "track_in_finance", false),
                  valuePropName: "checked",
                })(
                  <Checkbox>
                    {this.props.i18n.t(
                      "NamespaceSettingsPatientEventForm:Track in finance"
                    )}
                  </Checkbox>
                )}
              </label>
            </Col>
            <Col span={24}>
              <label>
                {getFieldDecorator("required_for_completion", {
                  initialValue: get(
                    this.props,
                    "required_for_completion",
                    false
                  ),
                  valuePropName: "checked",
                })(
                  <Checkbox>
                    {this.props.i18n.t(
                      "NamespaceSettingsPatientEventForm:Required for Milestone completion"
                    )}
                  </Checkbox>
                )}
              </label>
            </Col>
            <Col span={24}>
              <label>
                {getFieldDecorator("cf_field_required_for_billing_check", {
                  initialValue: !!get(
                    this.props,
                    "cf_field_required_for_billing",
                    false
                  ),
                  valuePropName: "checked",
                })(
                  <Checkbox>
                    {this.props.i18n.t(
                      "NamespaceSettingsPatientEventForm:Do not use completed status as trigger for follow up billing"
                    )}
                  </Checkbox>
                )}
              </label>
            </Col>
            {!!this.props.form.getFieldValue(
              "cf_field_required_for_billing_check"
            ) && (
              <Col span={24}>
                <br/>
                <label>
                  <b>Field required for billing</b>
                  <Form.Item>
                    {getFieldDecorator("cf_field_required_for_billing", {
                      initialValue: get(
                        this.props,
                        "cf_field_required_for_billing",
                        ""
                      ),
                    })(<Input type="text" />)}
                  </Form.Item>
                </label>
              </Col>
            )}
          </Row>

          <br />

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={classes.submitButton}
                >
                  {this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            }

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {isPredefined
                ? this.props.i18n.t("Close")
                : this.props.i18n.t("Cancel")}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = { logout };

export default Form.create({ name: "patient-event" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(SettingsPatientEventForm))
);



// WEBPACK FOOTER //
// ./src/containers/SettingsPatientEvents/SettingsPatientEventForm.js